const UserEntity = (backClient) => ({
  show: async () => await backClient.get(`/api/user`),
  availableProducts: async () =>
    await backClient.get(`/api/user/products/available`),
  update: async (data) => await backClient.put("/api/user", data),
  recordLogin: async () => await backClient.post("/api/user/record_login"),
  confirmEmail: async (data) =>
    await backClient.post("/api/confirm_email", data),
  delete: async (userId) => await backClient.delete(`/api/user/${userId}`),
})

export default UserEntity
